import FormBtn from './FormBtn';
import TextArea from './TextArea';
import TextField from './TextField';

const FormIcon = () => {
  return (
    <div className='form-icon'>
      <div className='form-icon__eyes'></div>
      <div className='form-icon__head'></div>
      <div className='form-icon__body'></div>
      <div className='form-icon__rfeet'></div>
      <div className='form-icon__lfeet'></div>
      <div className='form-icon__arm'></div>
    </div>
  );
};

const Form = (props) => {
  const {
    name,
    number,
    email,
    message,
    nameChangeHandler,
    numberChangeHandler,
    emailChangeHandler,
    sendEmail,
    messageChangeHandler,
    // validateNameHandler,
  } = props;

  return (
    <form className='form' onSubmit={sendEmail}>
      <TextField
        label='name'
        inputHandler={nameChangeHandler}
        value={name}
        type='text'
        // validateNameHandler={validateNameHandler}
      />

      <TextField
        label='Mobile'
        inputHandler={numberChangeHandler}
        value={number}
        type='number'
      />

      <TextField
        label='Email'
        inputHandler={emailChangeHandler}
        value={email}
        type='email'
      />

      <TextArea
        label='Drop a message'
        inputHandler={messageChangeHandler}
        value={message}
        row='5'
        col='40'
      />

      <FormBtn value='Submit' type='submit' />

      <FormIcon />
    </form>
  );
};

export default Form;
